import { Redirect, Route, Switch } from 'wouter-preact'

import { SignIn } from 'components'
import { AuthLayout, Profile } from 'pages'

import { AuthState, authState } from '../state'

const UnAuthenticatedRoutes = () => (
	<AuthLayout>
		<Switch>
			<Route path='/'>
				{authState.value === AuthState.signingUp ? (
					<Redirect to='/profile' />
				) : (
					<SignIn />
				)}
			</Route>
			<Route path='/profile'>
				{authState.value !== AuthState.signingUp ? (
					<Redirect to='/' />
				) : (
					<Profile />
				)}
			</Route>
			<Redirect to='/' />
		</Switch>
	</AuthLayout>
)

export { UnAuthenticatedRoutes }
